export default __webpack_public_path__ + "static/media/gleamer-logo.d67a2b79.svg";